module.exports = __webpack_public_path__ + "img/054-calendar.39240d02.svg";